import { render, staticRenderFns } from "./rankingType.vue?vue&type=template&id=4fc0cc78"
import script from "./rankingType.vue?vue&type=script&lang=js"
export * from "./rankingType.vue?vue&type=script&lang=js"
import style0 from "./rankingType.vue?vue&type=style&index=0&id=4fc0cc78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports